import * as jwt from 'jsonwebtoken';
import { publicKey } from '@/utils/constants';
import { tsNow } from '@/utils/timeSync';
import bizTransport from '@/modules/bizTransport';
import logger from '@/modules/Logger';
import store from '@/store/index';

class JWTHelper {
  constructor(publicKey, privateKey, options) {
    if (!publicKey) {
      logger.error('RSA public key for JWT validation is not configured',{event_type:34});
    }
    this.publicKey = publicKey;
    this.privateKey = privateKey;
    this.options = options;
    this.jwtError = null;
    this.unverifiedPayload = null;
  }

  verify(token) {
    this.unverifiedPayload = this.decodeWithoutVerify(token);
    const isCmsPreview = window.location.href.indexOf("/cms-preview/") > -1;
    if (isCmsPreview) {
      return this.unverifiedPayload;
    }
    // disable checking of token expiration due to uncertain sync time of frontend with server time
    const ignoreExpiration = { ignoreExpiration: true };

    return jwt.verify(token, this.publicKey, ignoreExpiration, (err, payload) => {
      if (err) {
        this.jwtError = err;
        this.logToken(err);
        return false;
      }
      return payload;
    });
  }

  decodeWithoutVerify(token) {
    return jwt.decode(token);
  }

  isGracePeriodEnd(token) {
    if (!token) {
      return true;
    }

    const decodedToken = this.decodeWithoutVerify(token);
    return decodedToken.g ? (decodedToken.g <= Math.floor(tsNow() / 1000)) : true;
  }

  sign(payload) {
    return jwt.sign(payload, this.privateKey, this.options);
  }

  logToken(jwtError, message = null) {
    // get user's date obj
    const date = new Date();

    // Log data
    const consolebizTransport = new bizTransport({ lessonToken: store.state.lessonToken });
    logger.add(consolebizTransport);

    if (jwtError) {
      const userDateTime = {
        name: jwtError.name,
        date: jwtError.date || '',
        userDate: date.toString()
      };
      logger.error('[JwtInvalidToken] ' + jwtError.message || '', { operation: 'jwt:verify', reason: userDateTime,event_type:35 });
    } else {
      logger.error('[JwtInvalidToken] ' + message || '[JwtInvalidToken] Jwt error - Invalid token error', { 
        operation: 'jwt:verify', reason: { userDate: date.toString(),event_type:36 }
      });
    }
    logger.info('Force sending of logs', { operation: 'send-batch-log' });
    logger.remove(consolebizTransport);
  }
}

let jwtHelperMyStage = new JWTHelper(publicKey);

export { JWTHelper, jwtHelperMyStage };
